module.exports = __webpack_public_path__ + "static/media/nonpublic.4a06649c.png";